export const galleryData = [
  {
    picture:
      "https://i.ibb.co/NLBvmZJ/Whats-App-Image-2021-11-30-at-18-50-02.jpg",
    description: "Match Day Screening 2021",
  },
  {
    picture:
      "https://i.ibb.co/8BnHTwD/Whats-App-Image-2021-11-30-at-18-52-47.jpg",
    description:
      "Jersey Collection from 2010 to 2018 (Abir Emon's Personal Collection) ",
  },
  {
    picture:
      "https://i.ibb.co/ChxVw8v/Whats-App-Image-2021-11-30-at-18-50-03.jpg",
    description: "#MCFCBD Football Team ",
  },
  {
    picture:
      "https://i.ibb.co/LPJWnNV/Whats-App-Image-2021-11-30-at-18-50-04.jpg",
    description: "Blue Citizens FC - 2021",
  },
  {
    picture:
      "https://i.ibb.co/ZYVmHr8/Whats-App-Image-2021-11-30-at-19-07-42.jpg",
    description: "2017 - #MCFCBD",
  },
  {
    picture:
      "https://i.ibb.co/m6Sv5dY/Whats-App-Image-2021-11-21-at-23-11-44.jpg",
    description: "Match Day Live Screening 2021",
  },
  {
    picture:
      "https://i.ibb.co/QQGts8W/Whats-App-Image-2021-11-29-at-23-53-28.jpg",
    description: " Winter in Manchester 2021",
  },
  {
    picture:
      "https://i.ibb.co/khsx4Zz/Whats-App-Image-2021-11-29-at-23-53-30-1.jpg",
    description: "Iconic 93.20 Moment - Sergio Aguero",
  },
  {
    picture:
      "https://i.ibb.co/4Tg7pzH/Whats-App-Image-2021-11-29-at-23-53-30.jpg",
    description: "Premeier League Champion 2017-18",
  },
  {
    picture:
      "https://i.ibb.co/yYRKLjM/Whats-App-Image-2021-11-29-at-23-53-31.jpg",
    description: "EFL Cup Champion 2019-20",
  },
  {
    picture:
      "https://i.ibb.co/02vgmdh/Whats-App-Image-2021-11-29-at-23-53-32.jpg",
    description: "Phil Foden Street Art",
  },

  {
    picture:
      "https://i.ibb.co/nDwh27N/Whats-App-Image-2021-11-29-at-23-53-31-2.jpg",
    description: "Manchester City Football Academy - UK",
  },
  {
    picture:
      "https://i.ibb.co/CHj8yRw/Whats-App-Image-2021-11-29-at-23-53-31-3.jpg",
    description: "Celebration PL - 2013-14",
  },
  {
    picture:
      "https://i.ibb.co/tKrnStP/Whats-App-Image-2021-11-29-at-23-53-32-1.jpg",
    description: "Etihad Stadium - UK Manchester",
  },

  {
    picture:
      "https://i.ibb.co/N6wwqCG/Whats-App-Image-2021-11-29-at-23-53-33.jpg",
    description: "Team Photo - 2021-22 ",
  },
];
